import React from "react";
import { formatTillAmount } from "./tillFormat";

const MinusIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12h14" />
  </svg>
);

const PlusIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

// Five-across denomination tiles (value + line amount, then − count +). The
// count input keeps name={denom.value} so the screen's own onFieldInput /
// onFieldOut handlers work unchanged.
const FashionDenomGrid = ({ denominations = [], currency = {}, onFieldInput, onFieldOut, onFieldButton }) => {
  const symbol = currency?.currSymbol ?? "₹";
  const right = currency?.symbolRightSide === "Y";
  return (
    <div className="ftill-denoms">
      {denominations.map((denom, index) => {
        const label = right ? `${denom.value}${symbol}` : `${symbol}${denom.value}`;
        return (
          <div className="ftill-denom" key={denom.value}>
            <div className="ftill-denom__top">
              <b className="ftill-denom__value">{label}</b>
              <span className="ftill-denom__amount">{formatTillAmount(denom.amount)}</span>
            </div>
            <div className="ftill-denom__count">
              <button type="button" className="ftill-iconbtn ftill-iconbtn--line" aria-label={`One less ${label}`} onClick={() => onFieldButton(index, "minus")}>
                <MinusIcon />
              </button>
              <input
                className="ftill-denom__input"
                aria-label={`Count of ${label}`}
                inputMode="numeric"
                name={`${denom.value}`}
                value={denom.count}
                onChange={onFieldInput}
                onBlur={onFieldOut}
              />
              <button type="button" className="ftill-iconbtn ftill-iconbtn--line" aria-label={`One more ${label}`} onClick={() => onFieldButton(index, "plus")}>
                <PlusIcon />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FashionDenomGrid;
